import { gtagProvider, tracker } from '@femtasy/helpers';

export default function triggerAnalyticsEvent({ event, ga = true }) {
  if (ga && window.ga) {
    window.ga('send', 'event', ...event);
  }

  if (ga) {
    tracker.sendEvent(
      event[1],
      [{ event_category: event[0], event_label: event[2] }],
      false,
      [gtagProvider],
    );
  }
}
